<div class="view-content">
  <p-tabs>
    <p-tablist>
      <p-tab value="0">Raw Interaction</p-tab>
      <p-tab value="1" [disabled]="true">Crawler</p-tab>
      <p-tab value="2" [disabled]="true">Stories</p-tab>
    </p-tablist>
    <p-tabpanels>
      <p-tabpanel value="0" class="raw-interaction-panel">
        <textarea class="raw-interaction" pTextarea rows="20"  [(ngModel)]="interactionPath" placeholder="Enter interaction path data"></textarea>
        <p-button (click)="executeInteractionPath()">Execute</p-button>
      </p-tabpanel>
    </p-tabpanels>
  </p-tabs>
</div>